"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentClient = void 0;
class ConsentClient {
    constructor(consentConfiguration, authService, stage) {
        this.consentConfiguration = consentConfiguration;
        this.authService = authService;
        this.stage = stage;
        this.headers = {
            'Content-Type': 'application/json',
        };
        this.getGdcType = (isWcar) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
        this.resourceHostId = `myvw-consent-${stage}`;
        this.resourceProxyId = `myvw-vehicle-consent-proxy-${stage}`;
    }
    async getVehicleSpecificConsent(vin, isWcar) {
        const url = `consent/v2/users/__userId__/vehicles/${vin}?gdc=${this.getGdcType(isWcar)}&client=__aud__&scopes=openid`;
        const response = await this.authService.get(this.resourceHostId, url);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async storeVehicleSpecificConsent(vin, isWcar) {
        const url = `consents/${vin}?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authService.post(this.resourceProxyId, url, undefined, this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    async storeConsentForMajorVersion(majorVersion, isWcar) {
        const url = `consent/v2/legal-text-consents/${this.consentConfiguration.appName}/__userId__/${this.consentConfiguration.termsAndConditionsTextId}/${this.consentConfiguration.countryCode}?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authService.post(this.resourceHostId, url, JSON.stringify({ majorVersion, language: this.consentConfiguration.language }), this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    async getLatestVersion(isWcar) {
        const url = `consent/v3/legal-text-consents/${this.consentConfiguration.appName}/__userId__/${this.consentConfiguration.termsAndConditionsTextId}/${this.consentConfiguration.countryCode}/${this.consentConfiguration.language}/details?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authService.get(this.resourceHostId, url);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        const data = await response.json();
        return data.latestVersion;
    }
}
exports.ConsentClient = ConsentClient;
//# sourceMappingURL=ConsentClient.js.map